export default "__VITE_ASSET__BN$m$Skm__"